import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import {BrowserRouter as Router, Switch,Route} from 'react-router-dom'
import Home from './components/pages/Home';
import Skills from './components/pages/Skills';
import Contact from './components/pages/Contact';

function App() {
  return (
    <>
    <Router>
      <Navbar/>
      <Switch>
        <Route path = '/' exact component = {Home} />
        <Route path = '/skills' component = {Skills}/>
        <Route path = '/contact' component = {Contact}/>
        
      </Switch>
    </Router>

    </>
  );
}

export default App;
